<template>

<app-table-cell class="item" :class="{'is-empty': !item, 'has-icon': showIcon, 'is-active': is.previewing}" :border="border">

	<div class="item-box">

        <template v-if="item">

            <app-icon :icon="preview.icon[type]" class="item-box-icon" v-if="showIcon" />

            <div class="item-box-info">

                <div class="item-box-name">{{ item.name || item.reference }}</div>

                <div class="item-box-reference" v-if="item.reference && (preview.reference[type] || noExtra) && item.name">{{ item.reference }}</div>

                <app-table-cell-item-role v-if="type === 'convention/volunteers/role' && !noExtra" :item="item" />
                <app-table-cell-item-slot v-if="type === 'convention/volunteers/slot' && !noExtra" :item="item" />
                <app-table-cell-item-sale v-if="type === 'convention/registration/sale' && !noExtra" :item="item" />

            </div>

            <app-icon icon="info" class="item-box-link" v-on:click.native.stop="onPreviewClick" v-tooltip="(item) ? preview.tooltip[type] : false" v-if="item.id" />

        </template>

        <template v-if="!item">

            <div class="item-box-empty">{{ emptyText || 'No item.' }}</div>

        </template>

    </div>

    <com-preview v-if="is.previewing" :type="type" :id="item.id" v-on:close="is.previewing = false" v-on:manage="onPreviewFollow($event)" />

</app-table-cell>

</template>

<script>

import mixPreview from './../../../preview/mixin'

export default {

	props: ['border', 'emptyText', 'showIcon', 'noExtra'],

    mixins: [mixPreview]

}

</script>

<style scoped>

.item {
    padding: 10px 0px 10px 10px;
}

.item-box {
    width: 100%;
    height: 100%;
    user-select: none;
    padding: 0px 0px;
    display: grid;
    align-items: center;
    grid-template-columns: auto 40px;
}

.item.is-active .item-box {
    border-color: #4082d3;
}

.item.has-icon .item-box {
    grid-template-columns: 26px auto 40px;
}

.item.is-empty .item-box {
    pointer-events: none;
    border: 0px;
    background-color: transparent;
}

.row:hover .item:not(.is-active) .item-box {
    border-color: transparent;
}

.item-box-empty {
    color: #999;
}

.item-box-info {
    padding-right: 10px;
}

.item-box-icon {
    text-align: left;
	color: #687589;
}

.item-box-name {
    font-size: 14px;
    line-height: 14px;
    color: #687589;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
}

.item-box-reference {
    font-size: 12px;
    line-height: 16px;
    color: #687589;
	opacity: 0.8;
    font-weight: 300;
}

.item-box-link {
	cursor: pointer;
	color: #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    font-size: 16px;
    height: 100%;
}

.item-box-link:hover {
    color: #333;
}

</style>
